import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IAcquirerTransactionsByNetworkCardTypeMeta{
  bank: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta, 
  currency: FormInputMeta,
  transactionCode: FormInputMeta,
  networkCardType: FormInputMeta,
  //  
  schema: any,
}

const AcquirerTransactionsByNetworkCardTypeMeta: IAcquirerTransactionsByNetworkCardTypeMeta= {} as IAcquirerTransactionsByNetworkCardTypeMeta;

AcquirerTransactionsByNetworkCardTypeMeta.bank = commonFormMeta.bank;
AcquirerTransactionsByNetworkCardTypeMeta.startDate = commonFormMeta.startDate;
AcquirerTransactionsByNetworkCardTypeMeta.endDate = commonFormMeta.endDate;


AcquirerTransactionsByNetworkCardTypeMeta.currency = {
  name: 'currency',
  type: 'select',
  label: 'Monnaie',
  options:  [
    {
      label: 'Monnaie A',
      value: 'a'
    },
    {
      label: 'Monnaie B',
      value: 'b',
    },
    {
      label: 'Monnaie C',
      value: 'b',
    },
  ],
  validation: yup.string(),
};

AcquirerTransactionsByNetworkCardTypeMeta.transactionCode = {
  name: 'transactionCode',
  type: 'select',
  label: 'Code transaction',
  options:  [
    {
      label: 'Code transaction A',
      value: 'a'
    },
    {
      label: 'Code transaction B',
      value: 'b',
    },
    {
      label: 'Code transaction C',
      value: 'b',
    },
  ],
  validation: yup.string(),
};

AcquirerTransactionsByNetworkCardTypeMeta.networkCardType = {
  name: 'networkCardType',
  type: 'select',
  label: 'Type carte reseau',
  options:  [
    {
      label: 'Type carte reseau A',
      value: 'a'
    },
    {
      label: 'Type carte reseau B',
      value: 'b',
    },
    {
      label: 'Type carte reseau C',
      value: 'b',
    },
  ],
  validation: yup.string(),
};

const validationSchema: any = {};

for (let fieldname in AcquirerTransactionsByNetworkCardTypeMeta) {
  validationSchema[fieldname] = (AcquirerTransactionsByNetworkCardTypeMeta as any)[fieldname].validation;
}

AcquirerTransactionsByNetworkCardTypeMeta.schema = yup.object().shape(validationSchema);

export default AcquirerTransactionsByNetworkCardTypeMeta;

